import { UseFormReturn } from 'react-hook-form'

import { RepayOverviewPanel } from '../components/RepayOverviewPanel'
import { PositionOverview } from '../logic/types'
import { TokenWithBalance } from '@/domain/common/types'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { DialogForm } from '@/features/dialogs/common/components/form/DialogForm'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog } from '@/features/dialogs/common/types'
import { SparkLendToken } from '@/features/sparklend/tokens/SparkLendToken'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'

export interface RepayViewProps {
  dialogTitle: string
  debtAsset: SparkLendToken
  repayOptions: TokenWithBalance[]
  assetsToRepayFields: FormFieldsForDialog
  form: UseFormReturn<AssetInputSchema>
  actionsViewState: ActionsViewState
  currentPositionOverview: PositionOverview
  updatedPositionOverview?: PositionOverview
}

export function RepayView({
  dialogTitle,
  debtAsset,
  repayOptions,
  assetsToRepayFields,
  form,
  actionsViewState,
  currentPositionOverview,
  updatedPositionOverview,
}: RepayViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>{dialogTitle}</DialogTitle>

      <FormAndOverviewWrapper>
        <DialogForm form={form} assetsFields={assetsToRepayFields} selectorAssets={repayOptions} />
        <RepayOverviewPanel
          debtAsset={debtAsset}
          currentPositionOverview={currentPositionOverview}
          updatedPositionOverview={updatedPositionOverview}
        />
      </FormAndOverviewWrapper>

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
